<div class="relative w-full min-h-screen overflow-x-hidden h-full overflow-y-auto" (click)="onExploreNow()">
    <div class="z-0 absolute inset-0 flex justify-center md:justify-center items-center w-full h-full">
        <img src="/png/[lead-gen]-Product-landing-page-on-app-for-Asahi’s-product.png" alt="Car Insurance Banner" loading="eager" decoding="async"
             fetchpriority="high" class="w-[200%] md:w-full h-full object-contain object-top"
            style="image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges;" />
    </div>
</div>
<router-outlet></router-outlet>